import { defaultContract, getContract } from "../contracts/getContract.js";
import { SenderArguments, Transaction } from "@ton/ton";
import { scoreName } from "../config/config.js";
import {
  IMintData,
  ITonContractParams,
  ITransactionSender,
} from "../types/types.js";

export interface MintScoreResult {
  mintToken: (params: ITransactionSender & IMintData) => undefined;
  getNewTxHash: (lastTx: Transaction) => string;
  checkMintingTxStatus: (updated: number, mintScore: number) => boolean;
  getMintingTxParams: (params: IMintData) => Promise<SenderArguments>;
}

const defaultMintContract = {
  mintToken: defaultContract["mintToken"],
  getNewTxHash: defaultContract["getNewTxHash"],
  checkMintingTxStatus: defaultContract["checkMintingTxStatus"],
  getMintingTxParams: defaultContract["getMintingTxParams"],
};

export function mintScore({ address }: ITonContractParams) {
  if (!address) {
    console.error(`No address:${address} provided`);
    return defaultMintContract;
  }

  const { mintToken, getNewTxHash, getMintingTxParams } = getContract(
    address,
    scoreName
  );

  return {
    mintToken,
    getNewTxHash,
    getMintingTxParams,
  };
}
